import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function ContactForm() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <section id="contact" className="py-24 md:py-32 bg-[#1E1A16]" data-id="element-37">
      <div className="container mx-auto px-6 md:px-12" data-id="element-38">
        <div className="max-w-2xl mx-auto" data-id="element-39">
          <motion.div className="text-center mb-16" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-40">
            <h2 className="font-serif text-4xl md:text-5xl mb-6" data-id="element-41">
              Reserva Tu <span className="text-gold italic" data-id="element-42">Experiencia</span>
            </h2>
            <p className="text-white/60 font-light" data-id="element-43">
              Déjanos tus datos y nos pondremos en contacto contigo para agendar
              tu cita.
            </p>
            <div className="w-24 h-[1px] bg-gold mx-auto mt-6" data-id="element-44"></div>
          </motion.div>

          <motion.div className="glass-card rounded-2xl p-8 md:p-12 shadow-2xl shadow-gold/5" initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.8,
          delay: 0.1
        }} data-id="element-45">
            {submitted ? <motion.div className="text-center py-8" initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5
          }} data-id="element-46">
                <div className="text-gold text-5xl mb-4" data-id="element-47">✓</div>
                <h3 className="font-serif text-2xl mb-3" data-id="element-48">¡Gracias!</h3>
                <p className="text-white/60 font-light" data-id="element-49">
                  Nos pondremos en contacto contigo pronto.
                </p>
              </motion.div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-50">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-51">
                  <div data-id="element-52">
                    <label className="block text-xs tracking-[0.15em] uppercase text-white/50 mb-2 font-medium" data-id="element-53">
                      Nombre
                    </label>
                    <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} required className="w-full bg-white/5 border border-white/10 rounded-xl px-5 py-3.5 text-white placeholder-white/30 focus:outline-none focus:border-gold/50 focus:ring-1 focus:ring-gold/50 focus:bg-white/10 transition-all font-light" placeholder="Tu nombre" data-id="element-54" />
                  </div>
                  <div data-id="element-55">
                    <label className="block text-xs tracking-[0.15em] uppercase text-white/50 mb-2 font-medium" data-id="element-56">
                      Apellido
                    </label>
                    <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required className="w-full bg-white/5 border border-white/10 rounded-xl px-5 py-3.5 text-white placeholder-white/30 focus:outline-none focus:border-gold/50 focus:ring-1 focus:ring-gold/50 focus:bg-white/10 transition-all font-light" placeholder="Tu apellido" data-id="element-57" />
                  </div>
                </div>
                <div data-id="element-58">
                  <label className="block text-xs tracking-[0.15em] uppercase text-white/50 mb-2 font-medium" data-id="element-59">
                    Correo Electrónico
                  </label>
                  <input type="email" name="email" value={formData.email} onChange={handleChange} required className="w-full bg-white/5 border border-white/10 rounded-xl px-5 py-3.5 text-white placeholder-white/30 focus:outline-none focus:border-gold/50 focus:ring-1 focus:ring-gold/50 focus:bg-white/10 transition-all font-light" placeholder="tu@email.com" data-id="element-60" />
                </div>
                <div data-id="element-61">
                  <label className="block text-xs tracking-[0.15em] uppercase text-white/50 mb-2 font-medium" data-id="element-62">
                    Teléfono
                  </label>
                  <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required className="w-full bg-white/5 border border-white/10 rounded-xl px-5 py-3.5 text-white placeholder-white/30 focus:outline-none focus:border-gold/50 focus:ring-1 focus:ring-gold/50 focus:bg-white/10 transition-all font-light" placeholder="(555) 000-0000" data-id="element-63" />
                </div>
                <div className="pt-6 flex justify-center" data-id="element-64">
                  <Button type="submit" className="w-full md:w-auto" data-id="element-65">
                    Enviar Solicitud
                  </Button>
                </div>
              </form>}
          </motion.div>
        </div>
      </div>
    </section>;
}